import React, { useState } from 'react';
import { Input, Modal } from 'antd';
import * as FaIcons from 'react-icons/fa';

const allIconNames = Object.keys(FaIcons).filter(name => name.startsWith('Fa'));

const IconPickerFontAwesome = ({ value, onChange, name }: any) => {
  const [visible, setVisible] = useState(false);
  const [selectedIcon, setSelectedIcon] = useState<string>(value || '');
  const [searchTerm, setSearchTerm] = useState('');

  const handleSelect = (iconName: string) => {
    setSelectedIcon(iconName);
    onChange?.(iconName);
    setVisible(false);
  };

  const filteredIcons = allIconNames.filter(iconName =>
    iconName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const SelectedIconComponent = selectedIcon ? (FaIcons as any)[selectedIcon] : null;

  return (
    <div>
      <Input
        readOnly
        addonBefore={SelectedIconComponent ? <SelectedIconComponent color="#2d9cdb" /> : null}
        value={selectedIcon}
        onClick={() => setVisible(true)}
        placeholder="Selecione um ícone"
      />

      <input type="hidden" name={name} value={selectedIcon} />

      <Modal
        title="Escolha um ícone"
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Input
          placeholder="Pesquisar..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          style={{ marginBottom: 16 }}
        />

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(40px, 1fr))',
            gap: 12,
            maxHeight: 300,
            overflowY: 'auto',
          }}
        >
          {filteredIcons.map(iconName => {
            const IconComponent = (FaIcons as any)[iconName];
            return (
              <div
                key={iconName}
                onClick={() => handleSelect(iconName)}
                style={{
                  textAlign: 'center',
                  cursor: 'pointer',
                  border: iconName === selectedIcon ? '2px solid #1890ff' : '1px solid transparent',
                  padding: 8,
                  borderRadius: 4,
                }}
                title={iconName}
              >
                <IconComponent color="#2d9cdb" size={24} />
              </div>
            );
          })}
          {filteredIcons.length === 0 && <p>Nenhum ícone encontrado</p>}
        </div>
      </Modal>
    </div>
  );
};

export default IconPickerFontAwesome;
